<template>
  <main>
    <notifications
      classes="my-style"
      group="urlCopiedSuccessful"
      :closeOnClick="true"
      width="100%"
      position="top"
    />
    <notifications
      classes="my-style"
      group="submitSignUpTrialsSuccessful"
      :closeOnClick="true"
      width="100%"
      position="top"
    />
    <v-btn
      v-if="showSubmitForm === false"
      color="#0089CB"
      fab
      fixed
      rounded
      width="180px"
      height="40px"
      class="join-study-popup-button hidden-md-and-up white--text"
      style="text-transform: none; bottom: 6%; left: 28%; font-weight: bold"
      @click="showSubmitForm = true"
      id="join-study-popup-button"
      >Join Study</v-btn
    >
    <v-dialog v-model="showSubmitForm" class="d-flex align-items-start">
      <v-card flat class="trail-detail-card pa-1">
        <div class="flex-column flex-row">
          <v-spacer style="flex-grow: 0.6 !important"></v-spacer>
          <v-card-text class="pa-8">
            <v-row no-gutters justify="center">
              <h3 class="text-md-center ml-3 mb-3 m-text-black">
                Sign up for the trials now
              </h3>
            </v-row>
            <v-form ref="form" lazy-validation>
              <v-container fluid class="pl-lg-3 pl-sm-0 pr-lg-3 pl-sm-0">
                <v-row no-gutters>
                  <v-text-field
                    outlined
                    label="Name"
                    validate-on-blur
                    v-model="userData.name"
                    :rules="nameRules"
                  >
                  </v-text-field>
                </v-row>
                <v-row no-gutters>
                  <v-text-field
                    outlined
                    label="Email"
                    validate-on-blur
                    v-model="userData.email"
                    :rules="emailRules"
                  >
                  </v-text-field>
                </v-row>
                <v-row no-gutters>
                  <v-text-field
                    outlined
                    label="Phone"
                    validate-on-blur
                    v-model="userData.phone"
                    :rules="phoneRules"
                    hint="Length must be between 7 to 15 characters"
                  >
                  </v-text-field>
                </v-row>
                <v-row no-gutters>
                  <v-textarea
                    auto-grow
                    outlined
                    label="Other Medical Conditions"
                    @focus="addFirstBullet()"
                    validate-on-blur
                    v-model="clientDetails"
                    @keydown.enter.prevent="addBullet()"
                    @keydown.delete="countBullets()"
                    hint="Insert upto three points"
                  >
                  </v-textarea>
                </v-row>
              </v-container>
              <v-row no-gutters justify="center">
                <v-btn
                  class="submit-btn white--text"
                  style="text-transform: none; font-weight: bold; width: 95%"
                  color="#00857C"
                  large
                  @click="submitForm"
                  :loading="submitting"
                  id="submit-button-mobile"
                  elevation="0"
                  >Submit</v-btn
                >
              </v-row>
            </v-form>
          </v-card-text>
          <v-spacer></v-spacer>
        </div>
      </v-card>
    </v-dialog>
    <section v-if="renderNow">
      <v-row>
        <v-col cols="8" id="header-bg" style="padding-left: 6vw">
          <v-card
            max-height="326"
            style="padding-top: 3vw; padding-bottom: 2vw"
            color="transparent"
            elevation="0"
          >
            <v-row style="margin-right: 2vw">
              <v-card-text :style="headingOneFont"
                >{{ tabcontent.title }}
              </v-card-text>
            </v-row>
            <v-row>
              <v-btn
                class="ma-2 text-capitalize no-background-hover"
                :style="headingFourFont"
                text
                v-bind="size"
                depressed
                elevation="0"
              >
                <img src="@/assets/Group_13.svg" />
                <span style="padding-left: 1vw">Nova Clinical Research</span>
              </v-btn>
              <v-btn
                color="#D1E9E8"
                class="ma-2 text-lowercase text-md-h6 font-weight-regular"
                v-bind="size"
                depressed
                elevation="0"
                href="https://www.clinicaltrials.gov"
                target="_blank"
              >
                <img width="16vw" src="@/assets/Vector.svg" /><span
                  style="color: #00857c; padding-left: 1vw"
                  :style="headingFourFont"
                  >clinicaltrials.gov</span
                >
              </v-btn>
            </v-row>
            <v-row></v-row>
          </v-card>
        </v-col>
        <v-col cols="4" style="padding-right: 6vw"
          ><v-card
            style="padding-top: 3vw; padding-bottom: 2vw; margin-left: 3vw"
            elevation="0"
          >
            <v-row><v-col>Share with</v-col></v-row>
            <v-row
              ><v-col class="d-flex d-sm-block justify-space-between">
                <v-btn
                  v-bind="size"
                  icon
                  class="no-background-hover"
                  elevation="0"
                >
                  <ShareNetwork
                    network="facebook"
                    :url="current_url"
                    title="Breaking Medical Frontiers: Discover the Latest Clinical Trials for Multiple Diseases"
                    description="Explore groundbreaking clinical trials offering hope and new treatment possibilities for multiple diseases. Stay informed about the latest advancements and join the movement towards a healthier future."
                    quote="Empowering Patients, Advancing Science: Unveiling Promising Clinical Trials for a Better Tomorrow. - Zeda"
                    hashtags="ClinicalTrials, MedicalAdvancements, HealthcareInnovation, DiseaseResearch, HopeForTomorrow, PatientEmpowerment, MedicalBreakthroughs, CuttingEdgeScience, TreatmentPossibilities, HealthRevolution"
                    ><v-img contain src="@/assets/facebook.svg" /></ShareNetwork
                ></v-btn>
                <v-btn
                  v-bind="size"
                  icon
                  class="no-background-hover"
                  style="margin-left: 2vw"
                  elevation="0"
                  href="mailto:"
                  ><v-img contain src="@/assets/email.svg"></v-img></v-btn
                ><v-btn
                  v-bind="size"
                  icon
                  class="no-background-hover"
                  style="margin-left: 2vw"
                  elevation="0"
                  @click="copyURLToClipboard()"
                  ><v-img contain src="@/assets/share.svg" /></v-btn></v-col
            ></v-row>
            <v-row>
              <v-col
                ><img src="@/assets/location.svg" /><span
                  style="padding-left: 1vw"
                  :style="paragraphOneFont"
                  >2010 59th St W, Bradenton, FL 34209</span
                ></v-col
              >
            </v-row>
            <v-row>
              <v-col
                ><img src="@/assets/phone.svg" /><span
                  style="padding-left: 1vw"
                  :style="paragraphOneFont"
                  >(941) 792-6564</span
                ></v-col
              >
            </v-row>
          </v-card></v-col
        >
      </v-row>

      <!-- commented out this div because its overriding its background color to another component. If commented out code breaks any design, please revert it -->
      <!-- <div
        class="hidden-md-and-up"
        style="
          top: 80px;
          position: fixed;
          z-index: 6;
          width: 100%;
          height: 8vh;
          background-color: white;
        "
      ></div> -->
      <v-tabs
        height="36"
        v-model="tab"
        class="hidden-md-and-up"
        background-color="#00857C"
        color="white"
        style="position: sticky; top: 64px; z-index: 6"
        slider-size="4"
        slider-color="#6ECEB2"
      >
        <v-tab
          v-for="item in tabNames"
          :key="item"
          style="
            max-height: 20px;
            min-height: 20px;
            display: inline-block;
            margin-top: 10px;
            text-transform: capitalize;
            color: white;
          "
        >
          <div style="font-size: 13px; position: relative">{{ item }}</div>
          <!--          <v-btn-->
          <!--              :dark="isTabActive(i)"-->
          <!--              :outlined="!isTabActive(i)"-->
          <!--              :color="isTabActive(i) ? '#0089CB' : '#aaaaaa'"-->
          <!--              style="border-radius: 6px; height: 36px; font-weight: normal; font-size: 12px;"-->
          <!--              :style="!isTabActive(i) ? `color: #666666; border-color: #0089CB` : ``"-->
          <!--          >{{ item }}-->
          <!--          </v-btn>-->
        </v-tab>
      </v-tabs>
      <!-- commented out this div because its overriding its background color to another component. If commented out code breaks any design, please revert it -->
      <!-- <div
        class="hidden-sm-and-down"
        style="
          top: 80px;
          position: fixed;
          z-index: 6;
          width: 50%;
          height: 8vh;
          background-color: white;
        "
      ></div> -->
      <v-tabs
        height="56"
        v-model="tab"
        background-color="#00857C"
        class="hidden-sm-and-down"
        slider-size="8"
        style="z-index: 6; position: sticky; top: 64px"
        ><v-tabs-slider color="#6ECEB2"></v-tabs-slider>
        <v-tab
          v-for="item in tabNames"
          :key="item"
          style="text-transform: capitalize; color: white"
          class="text-h6"
          >{{ item }}
          <!--          <v-btn-->
          <!--              :dark="isTabActive(i)"-->
          <!--              :outlined="!isTabActive(i)"-->
          <!--              :color="isTabActive(i) ? '#0089CB' : '#aaaaaa'"-->
          <!--              style="border-radius: 6px; height: 36px; font-weight: normal; font-size: 12px;"-->
          <!--              :style="!isTabActive(i) ? `color: #666666; border-color: #0089CB` : ``"-->
          <!--          >{{ item }}-->
          <!--          </v-btn>-->
        </v-tab>
      </v-tabs>
      <v-row no-gutters class="d-flex">
        <v-flex xs12 md6 lg7 style="margin-top: 20px">
          <v-card v-if="renderNow" flat style="margin-left: 6vw">
            <v-tabs-items v-model="tab" class="mr-6 mt-4">
              <v-tab-item
                v-for="(item, i) in tabNames"
                v-html="getTabContent(i + 1)"
                :key="i"
              ></v-tab-item>
            </v-tabs-items>
            <!--            <v-row class="mt-2" style="display: flex; justify-content: center;">-->
            <!--            </v-row>-->
          </v-card>
        </v-flex>
        <v-flex
          xs12
          md6
          lg5
          class="align-center justify-center form-background hidden-sm-and-down"
        >
          <v-layout align-center justify-center>
            <v-card flat class="mt-16 trail-detail-card pa-1">
              <div class="flex-column flex-row">
                <v-spacer style="flex-grow: 0.6 !important"></v-spacer>
                <v-card-text class="pa-8">
                  <v-row no-gutters justify="center">
                    <h3 class="text-md-center ml-3 mb-3 m-text-black">
                      Sign up for the trials now
                    </h3>
                  </v-row>
                  <v-form ref="form" lazy-validation>
                    <v-container fluid class="pl-lg-3 pl-sm-0 pr-lg-3 pl-sm-0">
                      <v-row no-gutters>
                        <v-text-field
                          outlined
                          label="Name"
                          validate-on-blur
                          v-model="userData.name"
                          :rules="nameRules"
                        >
                        </v-text-field>
                      </v-row>
                      <v-row no-gutters>
                        <v-text-field
                          outlined
                          label="Email"
                          validate-on-blur
                          v-model="userData.email"
                          :rules="emailRules"
                        >
                        </v-text-field>
                      </v-row>
                      <v-row no-gutters>
                        <v-text-field
                          outlined
                          label="Phone"
                          validate-on-blur
                          v-model="userData.phone"
                          :rules="phoneRules"
                          hint="Length must be between 7 to 15 characters"
                        >
                        </v-text-field>
                      </v-row>
                      <v-row no-gutters>
                        <v-textarea
                          auto-grow
                          outlined
                          label="Other Medical Conditions"
                          @focus="addFirstBullet()"
                          validate-on-blur
                          v-model="clientDetails"
                          @keydown.enter.prevent="addBullet()"
                          @keydown.delete="countBullets()"
                          hint="Insert upto three points"
                        >
                        </v-textarea>
                      </v-row>
                    </v-container>
                    <v-row no-gutters justify="center">
                      <v-btn
                        class="submit-btn white--text"
                        style="
                          text-transform: none;
                          font-weight: bold;
                          width: 95%;
                        "
                        large
                        color="#00857C"
                        @click="submitForm"
                        :loading="submitting"
                        id="submit-button-desktop"
                        elevation="0"
                        >Submit</v-btn
                      >
                    </v-row>
                  </v-form>
                </v-card-text>
                <v-spacer></v-spacer>
              </div>
            </v-card>
          </v-layout>
        </v-flex>
      </v-row>
    </section>
    <v-container
      v-else
      style="
        min-height: 70vh;
        display: flex;
        justify-content: center;
        align-items: center;
      "
    >
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-container>
  </main>
</template>

<script>
import axios from "axios";

export default {
  name: "AdTrialDetails",
  metaInfo() {
    return {
      title: this.tabcontent.title,
      meta: [
        { name: "description", content: this.tabcontent.meta_description },
      ],
    };
  },
  props: {
    id: String,
  },
  async created() {
    await this.getTrialContent();
    window.scrollTo(0, 0);
  },
  data() {
    return {
      showSubmitForm: false,
      headerBG: require("@/assets/Trial_cover.webp"),
      tab: null,
      userData: {
        study_id: this.id,
        name: "",
        email: "",
        phone: "",
        data: {},
      },
      nameRules: [(v) => !!v || "Name is required"],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      phoneRules: [
        (v) => !!v || "Phone number is required",
        (v) =>
          (v.length >= 7 && v.length <= 15) ||
          "Length must be between 7 and 15 characters",
      ],
      clientDetails: "",
      numOfLinesInData: 0,
      submitting: false,
      error: false,
      renderNow: false,
      errorMessage: undefined,
      tabcontent: [],
    };
  },
  methods: {
    copyURLToClipboard() {
      let val = window.location.href;
      navigator.clipboard
        .writeText(val)
        .then(() => {
          this.$notify({
            group: "urlCopiedSuccessful",
            title: "Your URL has been successfully copied!",
            text: "Now you can easily share it, explore it, or save it for later. Happy browsing!",
            duration: 5000,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    isTabActive(index) {
      return index === this.tab;
    },
    addFirstBullet() {
      if (this.clientDetails === "") {
        this.clientDetails = this.clientDetails + "\u2022 ";
      }
      this.numOfLinesInData = this.countBullets();
    },
    countBullets() {
      let count = 0,
        i = 0;
      for (i = 0; i <= this.clientDetails.length; i++) {
        if (this.clientDetails[i] == "\u2022") {
          count++;
        }
      }
      return count;
    },
    addBullet() {
      if (this.countBullets() < 3) {
        if (
          this.clientDetails.length == 0 ||
          this.clientDetails[this.clientDetails.length - 1] == "\n"
        ) {
          this.clientDetails = this.clientDetails + "\u2022 ";
        } else {
          this.clientDetails = this.clientDetails + "\n" + "\u2022 ";
        }
        this.numOfLinesInData = this.countBullets();
      }
    },
    clearUserData() {
      (this.userData.name = ""),
        (this.userData.email = ""),
        (this.userData.phone = ""),
        (this.userData.data = {}),
        (this.clientDetails = "");
    },
    async submitForm() {
      if (this.$refs.form.validate()) {
        let detailsData = new FormData();
        let i = 0;
        let stripData = this.clientDetails.replaceAll("\n", "");
        let splitData = stripData.split("\u2022");
        for (i = 1; i <= this.numOfLinesInData; i++) {
          detailsData.append("issue".concat(i.toString()), splitData[i]);
        }
        let clientDetailsObject = {};
        detailsData.forEach((value, key) => (clientDetailsObject[key] = value));
        this.userData.data = clientDetailsObject;
        try {
          this.submitting = true;
          await this.$store.dispatch("submitClientData", {
            userData: this.userData,
          });
          // await this.$router.push("/thank-you/" + this.id);
          this.$notify({
            group: "submitSignUpTrialsSuccessful",
            title:
              "Well done! You've successfully submitted your trial sign-up.",
            text: "Brace yourself for an incredible experience ahead. We're thrilled to have you.",
            duration: 5000,
          });
        } catch (e) {
          this.error = true;
          this.errorMessage = JSON.stringify(e);
          console.log(e);
        } finally {
          this.clearUserData();
          this.submitting = false;
        }
      }
    },
    getTrialContent() {
      let API_URL = process.env.VUE_APP_API_URL + "trials?trial_id=" + this.id;
      axios(API_URL, {
        method: "GET",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.tabcontent = response.data;
          this.renderNow = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getTabContent(index) {
      return this.tabcontent.page_content[index][0];
    },
  },
  computed: {
    current_url() {
      return window.location.href;
    },
    tabNames() {
      return this.tabcontent.page_content[0];
    },
    size() {
      const size = { xs: "x-small", sm: "small", lg: "large", xl: "x-large" }[
        this.$vuetify.breakpoint.name
      ];
      return size ? { [size]: true } : {};
    },
    headingOneFont() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size: 28px; line-height: 42px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Extra small screens (less than 600px)
        case "sm":
          return "font-size: 36px; line-height: 46px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Small screens (600px and up)
        case "md":
          return "font-size: 40px; line-height: 50px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Medium screens (960px and up)
        case "lg":
          return "font-size: 44px; line-height: 54px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Large screens (1264px and up)
        case "xl":
          return "font-size: 48px; line-height: 58px; font-weight: 700; font-family: 'Louis George Café'; color: #475560"; // Extra large screens (1904px and up)
        default:
          return "font-size: 48px; line-height: 58px; font-weight: 700; font-family: 'Louis George Café';  color: #475560";
      }
    },
    headingFourFont() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size: 16px; line-height: 20px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Extra small screens (less than 600px)
        case "sm":
          return "font-size: 20px; line-height: 24px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Small screens (600px and up)
        case "md":
          return "font-size: 20px; line-height: 24px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Medium screens (960px and up)
        case "lg":
          return "font-size: 24px; line-height: 28px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Large screens (1264px and up)
        case "xl":
          return "font-size: 24px; line-height: 32px; font-weight: 700; font-family: 'Louis George Café';  color: #475560"; // Extra large screens (1904px and up)
        default:
          return "font-size: 24px; line-height: 32px; font-weight: 700; font-family: 'Louis George Café';  color: #475560";
      }
    },
    paragraphOneFont() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size: 12px; line-height: 14px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Extra small screens (less than 600px)
        case "sm":
          return "font-size: 14px; line-height: 20px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Small screens (600px and up)
        case "md":
          return "font-size: 14px; line-height: 20px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Medium screens (960px and up)
        case "lg":
          return "font-size: 20px; line-height: 28px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Large screens (1264px and up)
        case "xl":
          return "font-size: 20px; line-height: 28px; font-weight: 400; font-family: 'Arial';  color: #475560"; // Extra large screens (1904px and up)
        default:
          return "font-size: 20px; line-height: 28px; font-weight: 400; font-family: 'Arial';  color: #475560";
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/scss/_colors";

.v-responsive__content {
  width: 52px !important;
}
.v-tabs-bar__content {
  margin-left: 6vw;
  color: white;
}

#header-bg {
  background-image: url("../../src/assets/Trial_cover.webp");
  background-size: cover;
  background-position: top right;
  position: relative;
}

.no-background-hover::before {
  background-color: transparent !important;
}
.join-study-popup-button {
}

.v-dialog.v-dialog--active {
  border-radius: 18px;
}

.v-dialog__container {
  display: unset;
}

.v-slide-group__prev {
  display: none !important;
}

//.mdi-chevron-right { // class responsible for the round tabs arrow
//  color: white !important;
//  border-radius: 38px;
//  width: 38px;
//  height: 38px;
//  background-color: #0089CB;
//  margin-top: 6px;
//  z-index: 1;
//}
//
//.mdi-chevron-left { // class responsible for the round tabs arrow
//  color: white !important;
//  border-radius: 38px;
//  width: 38px;
//  height: 38px;
//  background-color: #0089CB;
//  margin-top: 6px;
//  z-index: 1;
//}

.v-icon--disabled.mdi.mdi-chevron-right.theme--light {
  color: white !important;
  border-radius: 40px;
  display: none;
}

.v-icon--disabled.mdi.mdi-chevron-left.theme--light {
  color: white !important;
  border-radius: 40px;
  display: none;
}

v-icon.notranslate.mdi.mdi-chevron-left.theme--light {
  border-radius: 40px 40px 40px 40px;
}

.v-slide-group__prev {
  border-radius: 40px;
}

.v-tab--active {
  padding: 0px;
  margin: 0px;
}

.v-tab::before {
  color: transparent;
}

.v-slide-group__next {
  min-width: 40px;
  border-radius: 40px;
}

.v-slide-group__prev {
  min-width: 40px;
  border-radius: 40px;
}

.v-ripple__container {
  opacity: 0 !important;
}

.v-tab::after {
  opacity: 0 !important;
}

.v-slide-group__prev--disabled {
  display: none !important;
}

.trial-detail {
  //min-height: calc(80vh);
  background-color: #ffff;
}
@media screen and (min-width: 800px) {
  .form-background {
    min-height: 90vh;
    background: url("~@/assets/trails_form_bg.svg") !important;
    background-size: cover;
  }
}

.my-style {
  .notification-title {
    color: white;
    background-color: deepskyblue;
    text-align: center;
  }

  .notification-content {
    color: white;
    background-color: deepskyblue;
    text-align: center;
  }
}
.h1_class {
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: bold;
}

.h2_class {
  font-size: 14px;
}

//.m-trial-detail-page {
//  margin-top: 80px;
//}
.trial-content {
  margin-top: 50px;
  margin-bottom: 50px;

  p {
    color: $text;
    font-size: 16px;
    text-align: justify;
  }
  li {
    font-size: 16px;
    margin-top: 15px;
  }
}
.trail-detail-card {
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 20px !important;
  //min-height: 400px;
  width: 480px;

  @media (max-width: 600px) {
    //min-width: 100vw;
    //height: 100vh;
  }
  .v-card-title {
    padding-bottom: 5px;
  }
  .v-input--checkbox {
    .v-label {
      margin-bottom: 0;
    }
  }
  .theme--light.v-btn:hover::before {
    opacity: 0;
  }
}
.m-text-black {
  text-decoration-color: #424649 !important;
}
.submit-btn {
  min-width: 200px !important;
}
</style>
